import React from 'react';
import '../Colors.css';

const Schedule = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.465 283.632" enableBackground="new 0 0 283.465 283.632" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g id="bkg" display="none">
      </g>
      <g id="picto">
        <g>
          <path className='HslBlue' d="M78.103,12.56C34.972,12.56,0,47.549,0,90.709c0,43.158,34.972,78.155,78.103,78.155
            c43.143,0,78.109-34.997,78.109-78.155C156.212,47.549,121.246,12.56,78.103,12.56z M78.097,147.548
            c-31.362,0-56.793-25.441-56.793-56.83c0-31.383,25.431-56.823,56.793-56.823c31.374,0,56.793,25.441,56.793,56.823
            C134.891,122.107,109.471,147.548,78.097,147.548z"/>
          <path className='HslBlue' d="M96.803,69.027c-3.921,3.868-7.828,7.749-11.742,11.617c0-8.943,0-17.891,0-26.819
            c0-8.977-13.901-8.977-13.901,0c0,14.361,0,28.736,0,43.089c-0.007,0.344,0.013,0.681,0.063,1.018
            c0.238,3.016,2.111,4.927,4.44,5.691c2.196,0.976,4.813,0.85,7.065-1.179c0.076-0.063,0.146-0.119,0.224-0.19
            c0.021-0.013,0.049-0.028,0.063-0.048c7.869-7.785,15.746-15.561,23.608-23.352C113.02,72.551,103.186,62.717,96.803,69.027z"/>
        </g>
        <path className='Train' d="M269.869,113.509h-80.73c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h80.73c7.508,0,13.595,6.087,13.595,13.595v1.371C283.465,107.423,277.378,113.509,269.869,113.509z"/>
        <path className='Tram' d="M269.869,166.03h-97.457c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h97.457c7.508,0,13.595,6.087,13.595,13.595v1.371C283.465,159.944,277.378,166.03,269.869,166.03z"/>
        <path className='Metro' d="M269.869,218.551H83.468c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h186.402c7.508,0,13.595,6.087,13.595,13.595v1.371C283.465,212.464,277.378,218.551,269.869,218.551z"/>
        <path className='Metro' d="M34.116,218.551h-1.613c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h1.613c7.508,0,13.595,6.087,13.595,13.595v1.371C47.711,212.464,41.624,218.551,34.116,218.551z"/>
        <path className='Ferry' d="M269.869,271.072H83.468c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h186.402c7.508,0,13.595,6.087,13.595,13.595v1.371C283.465,264.985,277.378,271.072,269.869,271.072z"/>
        <path className='Ferry' d="M34.116,271.072h-1.613c-7.508,0-13.595-6.087-13.595-13.595v-1.371c0-7.508,6.087-13.595,13.595-13.595
          h1.613c7.508,0,13.595,6.087,13.595,13.595v1.371C47.711,264.985,41.624,271.072,34.116,271.072z"/>
      </g>
    </svg>
  );
};

export default Schedule;